module.exports = __webpack_public_path__ + "img/27b5f.994fc0d7.svg";